module.exports = __webpack_public_path__ + "img/doc.c2026911.svg";